import { Card, Heading, Inline, LinkButton, RichTextContent, Stack, Text, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { CaretDown } from '@phosphor-icons/react';
import { ExpandableContent } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const iconStyles = showMore => css`
  color: ${vars.colors.links.default};
  flex-shrink: 0;
  transform: rotateX(${showMore ? '180deg' : '0deg'});
  transition: transform 0.2s ease-in-out;
`;
const BundleModalContent = ({
  bundleDescription,
  bundleName,
  bundleReadMoreText,
  dimensions,
  id,
  piecesAndWeight,
  termsUrl
}) => {
  const {
    t
  } = useTranslation();
  const readMoreButtonText = t('Products.ReadMore.Link.Label');
  const readLessButtonText = t('Products.ReadLess.Link.Label');
  const coverGeniusPolicyLinkText = t('coverGeniusPolicyLinkText');
  const openInNewTabText = t('ScreenReader.Link.OpensInNewTab.AriaLabel.Text');
  const [showMore, setShowMore] = useState(false);
  const readMoreButtonLabel = showMore ? readLessButtonText : readMoreButtonText;
  const handleClick = () => {
    setShowMore(state => !state);
  };
  const termsLink = /*#__PURE__*/_jsx(Inline, {
    children: /*#__PURE__*/_jsx("a", {
      "aria-label": `${coverGeniusPolicyLinkText} (${openInNewTabText})`,
      href: termsUrl !== null && termsUrl !== void 0 ? termsUrl : undefined,
      rel: "noreferrer",
      target: "_blank",
      children: coverGeniusPolicyLinkText
    })
  });
  return /*#__PURE__*/_jsxs(Card, {
    children: [/*#__PURE__*/_jsx(Heading, {
      "data-testid": "ancillaryBundle-BundleHeader-title",
      level: 3,
      children: /*#__PURE__*/_jsxs("bdi", {
        children: [bundleName, piecesAndWeight && ` (${piecesAndWeight})`]
      })
    }), /*#__PURE__*/_jsx(RichTextContent, {
      children: bundleDescription
    }), /*#__PURE__*/_jsxs(Stack, {
      spacing: 4,
      children: [piecesAndWeight && /*#__PURE__*/_jsx(Text, {
        as: "bdi",
        children: piecesAndWeight
      }), dimensions && /*#__PURE__*/_jsx(Text, {
        as: "bdi",
        children: dimensions
      }), termsUrl && !bundleReadMoreText && termsLink, bundleReadMoreText && !piecesAndWeight && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Inline, {
          children: /*#__PURE__*/_jsx(LinkButton, {
            "aria-controls": `read-more-${id}`,
            "aria-expanded": showMore,
            "aria-label": `${readMoreButtonLabel} ${bundleName}`,
            "data-testid": "readMore-button",
            onClick: handleClick,
            children: /*#__PURE__*/_jsxs(Inline, {
              noWrap: true,
              spacing: 4,
              children: [readMoreButtonLabel, /*#__PURE__*/_jsx(CaretDown, {
                "aria-hidden": "true",
                className: iconStyles(showMore),
                size: 20,
                weight: "light"
              })]
            })
          })
        }), /*#__PURE__*/_jsxs(ExpandableContent, {
          isExpanded: showMore,
          children: [/*#__PURE__*/_jsx(RichTextContent, {
            id: `read-more-${id}`,
            children: bundleReadMoreText
          }), termsUrl && termsLink]
        })]
      })]
    })]
  });
};
export default BundleModalContent;
//# sourceMappingURL=BundleModalContent.js.map